export const API_BASE_URL = "https://react-quran-api.vercel.app";